(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-team-shop-uniform-tab"]) return;
  try {
    
  (() => {
    const scrollToHashTarget = () => {
      const url = new URL(window.location.href);
      if (!url.hash) return;

      const target = document.getElementById(url.hash.slice(1));
      if (target) target.scrollIntoView({ behavior: 'instant' });
    };

    const initializeTeamShop = (root) => {
      if (!root || root.dataset.teamShopInitialized === 'true') return;
      root.dataset.teamShopInitialized = 'true';

      const trigger = root.querySelector('[data-uniform-trigger]');
      const panel = root.querySelector('[data-uniform-panel]');
      const overlay = root.querySelector('[data-uniform-overlay]');
      const closeButton = root.querySelector('[data-uniform-close]');

      if (!trigger || !panel || !overlay || !closeButton) return;

      const desktopMedia = window.matchMedia('(min-width: 990px)');
      let isOpen = false;
      let lastFocusedElement = null;
      let previousOverflow = '';

      const usesDrawer = () => root.dataset.uniformMode === 'drawer' || !desktopMedia.matches;

      const getFocusableElements = () =>
        Array.from(
          panel.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => !element.hasAttribute('hidden'));

      const updateAccessibility = () => {
        const drawerMode = usesDrawer();

        if (drawerMode) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
          panel.inert = !isOpen;
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        } else {
          panel.setAttribute('role', 'complementary');
          panel.removeAttribute('aria-modal');
          panel.setAttribute('aria-hidden', 'false');
          panel.inert = false;
          trigger.setAttribute('aria-expanded', 'false');
        }
      };

      const closePanel = (restoreFocus = true) => {
        if (!isOpen) {
          updateAccessibility();
          return;
        }

        isOpen = false;
        root.classList.remove('is-uniform-open');
        document.documentElement.style.overflow = previousOverflow;
        updateAccessibility();

        if (restoreFocus && lastFocusedElement instanceof HTMLElement) {
          lastFocusedElement.focus();
        }
      };

      const openPanel = () => {
        if (!usesDrawer() || isOpen) return;

        isOpen = true;
        lastFocusedElement = document.activeElement;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        root.classList.add('is-uniform-open');
        updateAccessibility();

        window.requestAnimationFrame(() => closeButton.focus());
      };

      const syncResponsiveMode = () => {
        if (!usesDrawer()) closePanel(false);
        updateAccessibility();
      };

      trigger.addEventListener('click', openPanel);
      closeButton.addEventListener('click', () => closePanel());
      overlay.addEventListener('click', () => closePanel());

      root.addEventListener('keydown', (event) => {
        if (!isOpen) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closePanel();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = getFocusableElements();
        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      });

      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', syncResponsiveMode);
      } else {
        desktopMedia.addListener(syncResponsiveMode);
      }

      syncResponsiveMode();
    };

    const initializeAllTeamShops = (scope = document) => {
      scope.querySelectorAll('[data-team-shop]').forEach(initializeTeamShop);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          scrollToHashTarget();
          initializeAllTeamShops();
        },
        { once: true }
      );
    } else {
      scrollToHashTarget();
      initializeAllTeamShops();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllTeamShops(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
